import React from "react";
import { SectionErrorBoundary } from "../components/error-pages";

export function wrapHeavyFeaturePage(
  render: () => React.ReactElement,
  displayName: string
): React.ComponentType<unknown> {
  function HeavyFeatureRoute() {
    return (
      <SectionErrorBoundary onRetry={() => window.location.reload()}>
        {render()}
      </SectionErrorBoundary>
    );
  }
  HeavyFeatureRoute.displayName = `Route(${displayName})`;
  return HeavyFeatureRoute;
}
